module.exports = __webpack_public_path__ + "img/battle_section1_item2.e09c4250.png";